<template>
  <VxDialog
    v-model="visible"
    persistent
    no-back
    :v-size="'small'"
    :h-size="'xsmall'"
  >
    <template #innerDialog>
      <VxForm ref="form" @submit="addKey" @reset="onReset">
        <v-card>
          <v-card-text class="py-0">
            <v-img :src="logo" height="125" contain />
            <v-container>
              <p>
                {{ metadata.instructions.condition }}
              </p>
              <div class="mb-3">
                {{ metadata.instructions.text }}
                <strong>
                  {{ metadata.instructions.textBolded }}
                </strong>
              </div>
            </v-container>
            <VxTextField
              v-model="form.apiKey"
              :label="metadata.apiKeyInput.label"
              name="apiKey"
              :placeholder="metadata.apiKeyInput.placeholder"
              type="text"
              rules="required"
            />
            <v-fade-transition group>
              <VxAlert v-for="(error, idx) in errors" :key="idx" type="error">
                {{ error }}
              </VxAlert>
            </v-fade-transition>
          </v-card-text>
          <v-card-actions>
            <v-fade-transition>
              <span v-show="!!status" class="pl-2 text-caption text-truncate">
                {{ status }}
              </span>
            </v-fade-transition>
            <v-spacer />
            <VxBtn secondary @click="cancel">
              {{ metadata.cancelBtnText }}
            </VxBtn>
            <VxBtn :loading="submitting" @click="onSubmit">
              {{ metadata.addBtnText }}
            </VxBtn>
          </v-card-actions>
        </v-card>
      </VxForm>
    </template>
  </VxDialog>
</template>

<script>
import { useFormObject } from "@/mixins/useFormObject";
import { VxDialog, VxForm, VxTextField, VxAlert, VxBtn } from "@/core-ui";

export default {
  name: "ConnectAccountDialog",
  components: { VxDialog, VxForm, VxTextField, VxAlert, VxBtn },
  mixins: [
    useFormObject({
      prop: "auth",
      default: {
        apiKey: "",
      },
    }),
  ],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: (vm) => ({
    visible: !!vm.value,
    submitting: false,
    errors: [],
    status: "",
  }),
  computed: {
    logo() {
      return require("@/assets/automation/homebase-logo.png");
    },
    metadata() {
      return this.$t("settings.automation.homebase.connectAccount.dialog");
    },
  },
  watch: {
    value(value) {
      this.visible = !!value;
    },
    visible(value) {
      !!value !== this.value && this.$emit("input", value);
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    addKey(form) {
      this.submitting = true;
      this.$emit("addKey", {
        values: form.values,
        resolve: this.resolve,
        setErrors: this.setErrors,
        setStatus: this.setStatus,
      });
    },
    cancel() {
      this.resolve();
      this.$emit("cancel");
    },
    resolve() {
      this.visible = false;
      this.$refs.form.reset();
    },
    setErrors(errors) {
      this.submitting = false;
      this.errors = errors || [];
      this.status = "";
    },
    setStatus(status) {
      this.status = status;
    },
    onSubmit() {
      this.$refs.form.submit();
    },
    onReset() {
      this.status = "";
      this.errors = [];
      this.submitting = false;
      this.form.$reset();
    },
  },
};
</script>
